import React from 'react';
import { Link } from 'react-router-dom';
import { Link2, FolderOpen, Globe, Users, LogOut, ChevronDown, Key, ExternalLink } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../contexts/PermissionsContext';
import config from '../utils/config';
import { Avatar, AvatarImage, AvatarFallback } from '../ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '../ui/dropdown-menu';
import './Navigation.css';


function Navigation() {
  const { user, isAuthenticated, login, logout, token } = useAuth();
  const { permissions } = usePermissions();

  // Build admin portal URL with token and app_id for seamless SSO
  const getAdminUrl = (path: string) => {
    const baseUrl = `${config.authServiceAdminUrl}${path}`;
    // Pass token and app_id via URL hash so admin portal can use them directly
    // The app_id tells admin portal which app's permissions to check
    return token ? `${baseUrl}#token=${token}&app_id=${config.appId}` : baseUrl;
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="flex items-center gap-3">
          <Link to="/" className="nav-logo">
            <div className="nav-logo-icon"></div>
            <span className="nav-logo-text"></span>
          </Link>
        </div>

       

        <div className="nav-links">
          {isAuthenticated && (
            <>
            {/*  <Link to="/" className="nav-link">
                Home
          < /Link> */}
           <div className="flex items-center gap-1">
              <Link to="/manage"
               className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-blue-700'}`}
               title="Checkpoints">
                <Link2 className="w-4 h-4" />
                <span className="nav-link-text">Checkpoints</span>
              </Link>
              <Link to="/branding"
               className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-blue-700'}`}
               title="Domains">
                <Globe className="w-4 h-4" />
                <span className="nav-link-text">Domains</span>
              </Link>
              <Link to="/workspaces"
               className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-blue-700'}`}
               title="Workspaces">
                <FolderOpen className="w-4 h-4" />
                <span className="nav-link-text">Workspaces</span>
              </Link>
            </div>
            </>
          )}
        </div>

        <div className="nav-auth">
          {isAuthenticated && user ? (
            <div className="user-profile">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                    <Avatar className="user-avatar">
                      <AvatarImage src={user.picture} alt={user.name} />
                      <AvatarFallback>
                        {user.name
                          ?.split(' ')
                          .map(n => n[0])
                          .join('')
                          .toUpperCase()
                          .slice(0, 2) || 'U'}
                      </AvatarFallback>
                    </Avatar>
                    <span className="user-name">{user.name}</span>
                    <ChevronDown className="w-4 h-4" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56">
                  {(permissions?.role === 'admin' || permissions?.role === 'owner') && (
                    <>
                      <DropdownMenuItem asChild>
                        <a
                          href={getAdminUrl('/users')}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-2 cursor-pointer"
                        >
                          <Users className="w-4 h-4" />
                          User Management
                          <ExternalLink className="w-3 h-3 ml-auto opacity-50" />
                        </a>
                      </DropdownMenuItem>
                      <DropdownMenuItem asChild>
                        <a
                          href={getAdminUrl('/oauth-clients')}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-2 cursor-pointer"
                        >
                          <Key className="w-4 h-4" />
                          API Client Management
                          <ExternalLink className="w-3 h-3 ml-auto opacity-50" />
                        </a>
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                    </>
                  )}
                  <DropdownMenuItem onClick={logout} variant="destructive">
                    <LogOut className="w-4 h-4" />
                    Sign Out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          ) : (
            <button onClick={login} className="auth-btn login-btn">
              Sign In
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
